import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SnapShotService } from '../services/snap-shot.service';
import { RendererService } from '../services/renderer.service';
import { ProjectManagerService } from '../services/project-manager.service';
import { NgForm } from '@angular/forms';
import { ProToolsUiManagerService } from '../services/pro-tools-ui-manager.service';
import { DrawingsHolderService } from '../services/proTools/drawings-holder.service';

@Component({
  selector: 'app-save-pro-tools-actions',
  templateUrl: './save-pro-tools-actions.component.html',
  styleUrls: ['./save-pro-tools-actions.component.scss']
})
export class SaveProToolsActionsComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<SaveProToolsActionsComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private projectSrvc: ProjectManagerService,
    private drawings: DrawingsHolderService
  ) {
    this.projectSrvc.isSavedProject.subscribe(value => this.isSavedProject = value);
   }
  
   isSavedProject: boolean = false;
   imgNotes: string;
   imgUrl: string;
   snapshotsProTools = [];

 

  ngOnInit() {
  }

  dontSave() {
    this.drawings.setSaved(false);
    this.dialogRef.close(true);
  }

  save() {
    const items = this.drawings.getEditableItems();
    this.projectSrvc.setProToolsItems(items);
    this.projectSrvc.updateProject();
    this.drawings.setSaved(true);
    this.dialogRef.close(true);
  }

  cancel() {
      this.dialogRef.close(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/save-pro-tools-actions/save-pro-tools-actions.component.ts